import "./index.css";
import React from "react";

interface HelperProps {}

const Helper: React.FC<HelperProps> = function (props) {
  return (
    <>
      <div className={"bcfff"}>
        <div className={"fw700 fs18 helpSubTitle"}>常见问题</div>

        <div className={"questions"}>
          <a
            href="https://qw15p3s8hv.feishu.cn/wiki/wikcnU2ugomkarlIZKHz46zvpzf"
            target="_blank"
            className={"inlineBlock normalQuestion"}
          >
            常见问题1： 授权使用电子面单账号不成功？
          </a>
          <a
            href="https://qw15p3s8hv.feishu.cn/wiki/wikcnWTTZrEU5HrIhXmilp7a06b"
            target="_blank"
            className={"inlineBlock normalQuestion"}
          >
            常见问题2：共享电子面单给他人的问题？
          </a>
          <a
            href="https://qw15p3s8hv.feishu.cn/wiki/wikcn5zZx9gZnzwoVGHocScQQWg"
            target="_blank"
            className={"inlineBlock normalQuestion"}
          >
            常见问题3：如何查看谁在使用我的共享面单？
          </a>
          <a
            href="https://qw15p3s8hv.feishu.cn/wiki/Si91w0a4EixfI2kvfkBcx7dcn2e"
            target="_blank"
            className={"inlineBlock normalQuestion"}
          >
            常见问题4：如何在发货易中使用共享的电子面单？
          </a>
        </div>
      </div>

      <div className={"mt20 bcfff allCourse"}>
        <div className={"fw700 fs18 helpSubTitle"}>全部教程</div>

        <div className={"allCourseContent"}>
          <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnbqJTVf9DqYbla477gbXqHg" target="_blank" className={"course"}>
            授权电子面单账号
          </a>
          <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnSr94lgYjsdnJ0JrAHTt27a" target="_blank" className={"course"}>
            共享电子面单给他人
          </a>
          <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnYxoxcehdkW44v4VMD2nTkd" target="_blank" className={"course"}>
            增加、减少、暂停共享给别人的单号
          </a>
        </div>
        <div className={"allCourseContent"}>
          <a href="https://qw15p3s8hv.feishu.cn/wiki/Si91w0a4EixfI2kvfkBcx7dcn2e" target="_blank" className={"course"}>
            在发货易中使用电子面单
          </a>

          <a href="https://qw15p3s8hv.feishu.cn/wiki/IsENw5C1wi0VoLkwm6ycLmQCnRc" target="_blank" className={"course"}>
            共享面单系统-电子面单账号余额介绍
          </a>
        </div>
      </div>
    </>
  );
};

export default React.memo(Helper);
